import TabInfo from '@/views/App/Dashboard/HR/TabInfo.vue';
import SubmittedTimeSheets from '@/views/App/Dashboard/HR/TabSubmittedTimeSheets.vue';

const routesDashboardPersonal = [
    {
        path: 'info',
        name: 'dashboardPersonalInfo',
        component: TabInfo
    },
    {
        path: 'chart-overview',
        name: 'dashboardSubmittedTimeSheets',
        component: SubmittedTimeSheets
    }
  ];

export default routesDashboardPersonal;